import type { PoActivityActor, PoActivityPage, PoActivityQuery } from '@/types/poActivity';

import apiClient from './axios';

// Multi-value filters travel as one comma-separated value; an empty list is left out entirely.
const csv = (values: string[] | undefined): string | undefined => (values && values.length > 0 ? values.join(',') : undefined);

export async function fetchPoActivity(query: PoActivityQuery): Promise<PoActivityPage> {
  const { data } = await apiClient.get<PoActivityPage>('/po-activity', {
    params: {
      poNumber: query.poNumber || undefined,
      assignmentId: query.assignmentId || undefined,
      vendorIds: csv(query.vendorIds),
      actions: csv(query.actions),
      sources: csv(query.sources),
      actorEmails: csv(query.actorEmails),
      customerCodes: csv(query.customerCodes),
      from: query.from || undefined,
      to: query.to || undefined,
      cursor: query.cursor || undefined,
      limit: query.limit,
    },
    skipGlobalError: true,
  });
  return data;
}

export async function fetchPoActivityActors(): Promise<PoActivityActor[]> {
  const { data } = await apiClient.get<{ actors: PoActivityActor[] }>('/po-activity/actors', { skipGlobalError: true });
  return data.actors;
}
